import { gsap, ScrollTrigger } from "../../../gsap";
import Dom from "../../../dom";
export const InitializeFooterAnimation = () => {
  gsap.registerPlugin(ScrollTrigger);
  const tl = gsap.timeline({});
  const footer = document.querySelector(".site-footer");
  const eyebrow = footer.querySelector(".eyebrow");
  const fWrapper = document.querySelector(".site-footer-wrapper");
  const heading = document.querySelector(".site-footer-heading");
  const logo = document.querySelector(".animate-footer-logo");
  const elements = [logo, heading, fWrapper];
  const clipElements = [fWrapper];
  const animDuration = 0.3;

  if (Dom.prefersMotion) {
    
    tl.set(elements, {
      yPercent: 100,
    });
    tl.set(eyebrow, {
      opacity: 0,
    });
    ScrollTrigger.create({
      trigger: footer,
      start: "100px 95%",
      end: "100px 95%",
      once: true,

      onEnter: () => {
        if (heading) {
          tl.to(heading, {
            ease: "circ.inOut",
            duration: animDuration,
            yPercent: 0,
          });
        }
        tl.to(eyebrow, {
          ease: "circ.inOut",
          duration: animDuration,
          opacity: 1,
        })
        .to(clipElements, {
          ease: "circ.inOut",
          "clip-path": "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
          duration: animDuration,
          yPercent: 0,
        })
        .to(
          logo,
          {
            ease: "circ.inOut",
            duration: animDuration,
            yPercent: 0,
          },
          "-=" + animDuration
        );

        // Since gsap is calculating yPercent in pixels,
        // we'll remove the transform from the logo so it positions well
        // on resize
        setTimeout(() => {
          logo.style.transform = '';
        }, ((animDuration * 1000) + 1000));
      },
    });
  }
};
